
<template>
  <div class="main_empty"
       v-show="isShow">
    <div class="shadow"></div>
    <div class="footer">
      <div class="item">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isShow'],
  data () {
    return {
    }
  },
  components: {

  },

  mounted () {

  },
  watch: {

  },
  methods: {
  }
}
</script>
<style scoped>
.main_empty {
  width: 100%;
  height: 100%;
}
.shadow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(78, 78, 78);
  opacity: 0.4;
  z-index: 11;
}
.footer {
  position: fixed;
  left: 50%;
  z-index: 111;
  top: 50%;
  transform: translate(-50%, -50%);
}
.item {
  background: url("../assets/img/common/loading.gif") no-repeat center center;
  background-size: 100%;
  width: 2rem;
  height: 2rem;
  display: inline-block;
  margin-right: 0.1rem;
}
</style>